/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DisplayRef,
  DisplayRef$inboundSchema,
  DisplayRef$Outbound,
  DisplayRef$outboundSchema,
} from "./displayref.js";
import {
  EBIcon,
  EBIcon$inboundSchema,
  EBIcon$Outbound,
  EBIcon$outboundSchema,
} from "./ebicon.js";

export type RelatedDevice = {
  /**
   * The attributes of the device, the User can specify metrics or settings to display in the Equipment Details Screen.
   */
  attributes: Array<DisplayRef>;
  /**
   * The name of the device
   */
  displayName: string;
  /**
   * A single icon to display
   */
  icon: EBIcon;
};

/** @internal */
export const RelatedDevice$inboundSchema: z.ZodType<
  RelatedDevice,
  z.ZodTypeDef,
  unknown
> = z.object({
  attributes: z.array(DisplayRef$inboundSchema),
  display_name: types.string(),
  icon: EBIcon$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "display_name": "displayName",
  });
});
/** @internal */
export type RelatedDevice$Outbound = {
  attributes: Array<DisplayRef$Outbound>;
  display_name: string;
  icon: EBIcon$Outbound;
};

/** @internal */
export const RelatedDevice$outboundSchema: z.ZodType<
  RelatedDevice$Outbound,
  z.ZodTypeDef,
  RelatedDevice
> = z.object({
  attributes: z.array(DisplayRef$outboundSchema),
  displayName: z.string(),
  icon: EBIcon$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    displayName: "display_name",
  });
});

export function relatedDeviceToJSON(relatedDevice: RelatedDevice): string {
  return JSON.stringify(RelatedDevice$outboundSchema.parse(relatedDevice));
}
export function relatedDeviceFromJSON(
  jsonString: string,
): SafeParseResult<RelatedDevice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RelatedDevice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RelatedDevice' from JSON`,
  );
}
